/* eslint-disable */
import {AfterViewInit, Component, Injector, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {QueryFieldModel, UiConstants} from '../../../util/core-utils';
import {User, UserService} from '../../../lib/user.service';
import {OrderType, QueryResult, ResourceQueryResult} from '../../../lib/util/services';
import {ClientDocument, ClientDocumentService} from '../../../lib/client-document/client-document.service';
import {Dates, OffsetDateTime} from '../../../lib/util/dates';
import {CustomerRecord, CustomerRecordService} from '../../../lib/customer/customer-record.service';
import {combineLatest, empty, Observable} from 'rxjs';
import {Set} from 'immutable';
import {DownloadedFile} from '../../../lib/util/downloaded-files';
import {saveAs} from 'file-saver';
import {DqlSearchContainerComponent} from '../../dql-search/dql-search-container/dql-search-container.component';
import {ColonnadeDqlService} from '../../../lib/colonnade-insurance/colonnade-dql.service';
import {
  ColonnadeInsuranceSearch,
  ColonnadeInsuranceSearchService
} from '../../../lib/colonnade-insurance/colonnade-insurance-search.service';
import {map} from 'rxjs/operators';
import {DqlStoredQueryArgs} from '../../dql-search/dql-search-container/dql-stored-query.args';
import {RightModel} from '../../../app.rights';
import {RightResolver, RightService} from '../../../lib/right.service';
import {DqlDialogContainerComponent} from "../../dql-search/dql-dialog-container/dql-dialog-container.component";
import {
  ColonnadeInsuranceEmailSendDialogComponent
} from "../colonnade-insurance-email-send-dialog/colonnade-insurance-email-send-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {SearchUtils} from "../../../util/search-utils";
import {MatConfirmDialogComponent} from "../../../shared/mat-confirm-dialog/mat-confirm-dialog.component";
import {AlertType} from "../../../shared/confirm-dialog/confirm-dialog.component";
import SearchModel = SearchUtils.SearchModel;
import SearchableList = SearchUtils.SearchableList;

/* eslint-enable */

@Component({
  selector: 'app-colonnade-insurance-list',
  templateUrl: './colonnade-insurance-list.component.html',
  styleUrls: ['./colonnade-insurance-list.component.scss']
})
export class ColonnadeInsuranceListComponent extends SearchableList<ColonnadeInsuranceListSearchModel> implements OnInit, AfterViewInit, OnDestroy {

  ClientDocument = ClientDocument;
  UiConstants = UiConstants;
  queryModel: QueryFieldModel<ClientDocument.OrderField> = new QueryFieldModel(ClientDocument.OrderField.EVENT_TIME, OrderType.DESC);
  insuranceList: ClientDocumentModel[] = [];
  dqlStoredArgs: DqlStoredQueryArgs;
  rightModel: RightModel = RightModel.empty();

  private readonly documentType = 'colonnade_insurance_1';
  private dqlSearchContainer?: DqlSearchContainerComponent;
  private _type: ColonnadeInsuranceListType;

  @Input()
  set type(value: ColonnadeInsuranceListType) {
    this._type = value;
    this.dqlStoredArgs = {
      service: this.clientDocumentService.dqlStoredQueryService,
      parentId: undefined,
      documentType: this.documentType,
      documentListType: value
    };
  }

  get type(): ColonnadeInsuranceListType {
    return this._type;
  }

  @Input()
  dqlDialogHolder: DqlDialogContainerComponent;

  private _selectedInsuraces: string[] = [];
  private paymentTypes = [
    {id: 'csoportos', stringKey: 'INSURANCE_FORM_PAYMENT_TYPE_GROUP', iconClass: 'icomoon-insurance-payment-group'},
    {
      id: 'atutalas',
      stringKey: 'INSURANCE_FORM_PAYMENT_TYPE_TRANSFER',
      iconClass: 'icomoon-insurance-payment-transfer'
    },
    {
      id: 'munkaberbol_levonas',
      stringKey: 'INSURANCE_FORM_PAYMENT_TYPE_PAYROLL',
      iconClass: 'icomoon-insurance-payment-payroll'
    },
  ];

  get pagingId() {
    return this.isOfferList() ? 'offerPaging' : 'insurancePaging';
  }

  constructor(
    injector: Injector,
    private userService: UserService,
    private rightService: RightService,
    private dialog: MatDialog,
    private customerRecordService: CustomerRecordService,
    private clientDocumentService: ClientDocumentService,
    private colonnadeInsuranceSearchService: ColonnadeInsuranceSearchService,
  ) {
    super(ColonnadeInsuranceListSearchModel, injector);
  }

  onFirstSearchOpen(): void {

  }

  @ViewChild('dqlSearchContainer') set dqlContainer(c: DqlSearchContainerComponent) {
    if (c) {
      if (!this.dqlSearchContainer) {
        const qt = this.searchModel.dqlText;
        this.dqlSearchContainer = c;
        this.loadDqlModel(() => {
          this.loadDqlSearch(qt);
          this.dqlSearchContainer!.loadContent();
        });
      }
    } else {
      this.dqlSearchContainer = undefined;
    }
  }

  get allInsurancesSelected(): boolean {
    return this._selectedInsuraces.length === this.insuranceList.length && this.insuranceList.length !== 0;
  }

  ngOnInit() {
    this.loadRightModel(() => {
      this.loadSearch(() => {
        this.loadList();
      });
    });
  }

  ngAfterViewInit() {
  }

  loadDqlSearch(queryString?: string) {
    this.dqlSearchContainer!.loadQuery(queryString);
  }

  loadDqlModel(completion?: () => void) {
    this.dqlSearchContainer!.setFields(this.type === ColonnadeInsuranceListType.INSURANCE ? ColonnadeDqlService.getInsuranceDqlModel() : ColonnadeDqlService.getOfferDqlModel(),
      ColonnadeDqlService.getHelper(),
      completion ? completion : () => {
      });
  }

  downloadZip() {
    this.clientDocumentService.downloadZip({
      ids: this._selectedInsuraces.length > 0 ? Set.of(...this._selectedInsuraces) : undefined,
      submittedOnly: true,
      dql: this.searchModel.dqlText,
      documentType: this.documentType,
    }).subscribe(
      (res: DownloadedFile) => {
        saveAs(res.getBlob(), res.getFileName('colonnade-finance-1.zip'));
      });
  }

  downloadMergedZip() {
    this.clientDocumentService.downloadMergedZip({
      ids: this._selectedInsuraces.length > 0 ? Set.of(...this._selectedInsuraces) : undefined,
      submittedOnly: true,
      dql: this.searchModel.dqlText,
      documentType: this.documentType,
    }).subscribe(
      (res: DownloadedFile) => {
        saveAs(res.getBlob(), res.getFileName('colonnade-finance-1-merged.zip'));
      });
  }

  pageChanged(selectedPage: number) {
    this.loadList(selectedPage);
  }

  itemsPerPageChanged(itemsPerPage: number) {
    this.queryModel.itemsPerPage = itemsPerPage;
    this.loadList(1);
  }

  orderBy(field: ClientDocument.OrderField) {
    this.queryModel.onOrderFieldChanged(field);
    this.loadList(1);
  }

  onDqlSearchClicked() {
    this.searchModel.clear();
    this.searchModel.dqlText = this.dqlSearchContainer!.getQueryString();
    this.loadList(1);
  }

  allSelected() {
    if (!this.allInsurancesSelected) {
      this._selectedInsuraces = this.insuranceList.map(i => i.id);
    } else {
      this._selectedInsuraces = [];
    }
  }

  toggleSelected(id: string) {
    const idx = this._selectedInsuraces.findIndex(value => value === id);
    if (idx > -1) {
      this._selectedInsuraces.splice(idx, 1);
    } else {
      this._selectedInsuraces.push(id);
    }
  }

  isSelected(id: string) {
    const idx = this._selectedInsuraces.findIndex(value => value === id);
    return idx >= 0;
  }

  anySelected(): boolean {
    return this._selectedInsuraces.length > 0;
  }

  openEmailDialog() {
    this.queryPdfIds().subscribe((ids: number[]) => {
      ColonnadeInsuranceEmailSendDialogComponent.openDialog(this.dialog, {
        generalPdfIds: ids,
      }, result => {
      })
    });
  }

  tryOfferEmailResend() {
    const activeSelectedIds: string[] = [];
    this._selectedInsuraces.forEach(s => {
      const ins = this.insuranceList.find(i => i.id === s);
      if (ins && !ins.deleted) {
        activeSelectedIds.push(s);
      }
    })
    const count = activeSelectedIds.length;
    MatConfirmDialogComponent.openDialog(this.dialog, {
        alertType: AlertType.WARNING,
        messageKey: 'CLIENT_DOCUMENT_OFFER_EMAIL_RESEND_MESSAGE',
        titleKey: 'CLIENT_DOCUMENT_OFFER_EMAIL_RESEND_TITLE',
        messageParameters: {count: count}
      },
      result => {
        if (result !== undefined && result) {
          this.clientDocumentService.resendOfferEmail({
            ids: Set.of(...activeSelectedIds),
            documentType: this.documentType
          }).subscribe(r => {
          })
        }
      });
  }

  queryPdfIds(): Observable<number[]> {
    return this.clientDocumentService.query({
      ids: this._selectedInsuraces.length > 0 ? Set.of(...this._selectedInsuraces) : undefined,
      submittedOnly: true,
      dql: this.searchModel.dqlText,
      documentType: this.documentType,
    }).pipe(map((result: QueryResult<ClientDocument.ClientDocument>) => {
      const pdfIds: number[] = result.items.filter(i => i !== null && i !== undefined && i.pdfId !== undefined)
        .map(i => i!.pdfId!).toArray();
      return pdfIds;
    }));
  }

  getPaymentTypeIcon(paymentTypeCode: string) {
    const item = this.paymentTypes.find(p => p.id === paymentTypeCode);
    if (!item) {
      return '';
    }
    return item.iconClass;
  }

  isOfferList(): boolean {
    return this.type === ColonnadeInsuranceListType.OFFER;
  }

  ngOnDestroy(): void {
    this.saveSearch();
  }

  private loadRightModel(completion: () => void) {
    this.rightService.getRightResolver().subscribe(
      (resolver: RightResolver) => {
        this.rightModel = RightModel.of(resolver);
        completion();
      }
    );
  }


  loadSearch(completion: () => void) {
    let obs: Observable<SearchLoadResult>;
    obs = this.colonnadeInsuranceSearchService.getSearchData({listIdentifier: this.type}).pipe(map((storedSearchData) => {
      const result: SearchLoadResult = {
        storedSearchData: storedSearchData
      };
      return result;
    }));
    obs.subscribe(
      (result: SearchLoadResult) => {
        this.postInitSearch(result.storedSearchData);
        completion();
      }
    );
  }

  loadList(pageNumber?: number) {
    if (this.rightModel.clientDocumentRead.hasRight()) {
      const requestedPage = pageNumber ? pageNumber : this.queryModel.currentPage;
      const order = this.queryModel.getOrder();
      this.insuranceList = [];

      let dqlQuery = this.searchModel.dqlText;

      this.clientDocumentService.query({
        submittedOnly: this.type === ColonnadeInsuranceListType.INSURANCE,
        offerOnly: this.type === ColonnadeInsuranceListType.OFFER,
        dql: this.searchModel.dqlText,
        documentType: this.documentType,
        orders: Set.of(order),
        paging: requestedPage ? {
          pageNumber: requestedPage,
          numberOfItems: this.queryModel.itemsPerPage
        } : undefined
      }).subscribe((result: QueryResult<ClientDocument.ClientDocument>) => {
        this._selectedInsuraces = [];
        const customerRecordIds: number[] = [];
        const userIds: number[] = [];
        result.items.forEach((item: ClientDocument.ClientDocument) => {
          if (item.customerRecordId) {
            customerRecordIds.push(item.customerRecordId);
          }
        });
        result.items.forEach((item: ClientDocument.ClientDocument) => {
          if (item.submitterUserId) {
            userIds.push(item.submitterUserId);
          }
          if (item.offerUserId) {
            userIds.push(item.offerUserId);
          }
        });
        this.createCombinedObservable(customerRecordIds, userIds).subscribe(
          (combinedResult: CombinedResult) => {
            this.insuranceList = [];
            result.items.forEach((item: ClientDocument.ClientDocument) => {
              const client = combinedResult.customerRecord.find((c) => c!.customerRecordId === item.customerRecordId);
              const submitter = combinedResult.user.items.find((u) => u.id === item.submitterUserId);
              const offerUser = combinedResult.user.items.find((u) => u.id === item.offerUserId);
              const insuranceItem = new ClientDocumentModel();
              insuranceItem.id = item.id;
              insuranceItem.externalId = this.isOfferList() ? item.offerId! : item.externalId;
              insuranceItem.clientName = client ? client.name : '';
              insuranceItem.creatorName = submitter ? submitter.person_name : offerUser ? offerUser.person_name : '';
              if (item.form.insuranceProduct && item.form.insuranceProduct.text) {
                insuranceItem.insuranceProductType += item.form.insuranceProduct.text;
              }
              if (item.form.sponsor && item.form.sponsor.text) {
                insuranceItem.sponsorName += item.form.sponsor.text;
              }
              if (item.form.insuranceType && item.form.insuranceType.text) {
                insuranceItem.insuranceMode += item.form.insuranceType.text;
              }
              if (item.form.insuranceLevel && item.form.insuranceLevel.level) {
                insuranceItem.insuranceLevel += item.form.insuranceLevel.level;
              }
              if (item.form.paymentType && item.form.paymentType.code) {
                insuranceItem.paymentTypeCode = item.form.paymentType.code;
              }
              if (item.form.paymentType && item.form.paymentType.text) {
                insuranceItem.paymentTypeText = item.form.paymentType.text;
              }
              insuranceItem.hasPdf = item.pdfId !== undefined;
              insuranceItem.submitTime = this.isOfferList() ? item.offerTime : item.submitTime;
              insuranceItem.deleted = item.state === ClientDocument.State.DELETED || item.state === ClientDocument.State.DELETED_OFFER;
              insuranceItem.deletionCause = item.form.deletionCause;
              insuranceItem.deletionDate = item.form.deletionDate;
              this.insuranceList.push(insuranceItem);
            });
          });
        this.queryModel.currentPage = requestedPage;
        this.queryModel.totalNumberOfItems = result.pagingResult.totalNumberOfItems;
        this.queryModel.currentNumberOfItems = result.pagingResult.currentNumberOfItems;
      });
    }
  }

  private postInitSearch(storedSearchData: ColonnadeInsuranceSearch.SearchDataResult) {
    this.searchModel.dqlText = storedSearchData.searchData.dqlText;
  }

  private createCombinedObservable(customerRecordIds: number[], userIds: number[]): Observable<CombinedResult> {
    return combineLatest(
      userIds.length === 0 ? empty() : this.userService.query({id: userIds.join(',')}),
      this.customerRecordService.listQuery({
        customerRecordIdSet: customerRecordIds.length > 0 ? Set.of(...customerRecordIds) : undefined
      }),
      (user: ResourceQueryResult<User>,
       customerRecord: CustomerRecord.CustomerRecord[]) => {
        return {
          user: user,
          customerRecord: customerRecord
        };
      }
    );
  }

  private downloadPdf(id: string) {
    this.clientDocumentService.downloadPdf({
      id: id,
      documentType: this.documentType
    }).subscribe(
      (res: DownloadedFile) => {
        saveAs(res.getBlob(), res.getFileName('colonnade-finance-1.pdf'));
      });
  }

  private saveSearch() {
    const searchData = {
      dqlText: this.searchModel.dqlText,
      listIdentifier: this.type,
      itemsPerPage: this.queryModel.itemsPerPage,
      pageNumber: this.queryModel.currentPage,
      order: this.queryModel.getOrder(),

    };
    this.colonnadeInsuranceSearchService.setSearchData({searchData: searchData}).subscribe(
      (result) => {
      },
      (error) => {
      }
    );
  }

}

interface CombinedResult {
  user: ResourceQueryResult<User>;
  customerRecord: CustomerRecord.CustomerRecord[];
}

export class ClientDocumentModel {
  id: string;
  externalId: string = '';
  clientName: string = '';
  sponsorName: string = '';
  insuranceProductType: string = '';
  paymentTypeCode: string = '';
  paymentTypeText: string = '';
  insuranceMode: string = '';
  insuranceLevel: string = '';
  creatorName: string = '';
  hasPdf: boolean = false;
  submitTime: OffsetDateTime = Dates.emptyOffsetDateTime();
  deleted: boolean = false;
  deletionCause?: string;
  deletionDate: OffsetDateTime = Dates.emptyOffsetDateTime();
}

export class ColonnadeInsuranceListSearchModel extends SearchModel {
  dqlText?: string = undefined;

  public isEmpty(): boolean {
    return this.dqlText === undefined;
  }

  public clear() {
    this.dqlText = undefined;
  }

}

interface SearchLoadResult {
  storedSearchData: ColonnadeInsuranceSearch.SearchDataResult,
}

export enum ColonnadeInsuranceListType {
  INSURANCE = 'INSURANCE',
  OFFER = 'OFFER'
}
